import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Campaign, CampaignStatus } from '../../../../../../types/campaign.interface';
import { toCampaignMinute } from '../../../../../../types/campaign.utils';

/**
 * Builds a synchronous validator flagging an asset's UTC minute as taken when one of the already
 * loaded campaigns (`getAssetCampaigns`) sits on the same minute. Models, cancelled campaigns,
 * merge-archived sources (`originalCampaignId` set) and `excludeCampaignId` (the campaign being
 * edited) are ignored — the same liveness predicate the backend `validate_campaign_timestamp_unique`
 * applies, here approximated against the already-loaded open slice (the backend 409 stays
 * authoritative for anything outside it). Running against in-memory data keeps the inline error and
 * greyed Valider synchronous — no async/pending state, so the submit button never flashes
 * enabled-then-disabled and can't be double-fired.
 */
export function campaignMinuteTakenValidator(getAssetCampaigns: () => Campaign[], excludeCampaignId?: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value as string | Date | null | undefined;
    if (value === null || value === undefined || value === '') return null;

    const probedDate = new Date(value);
    if (Number.isNaN(probedDate.getTime())) return null;

    const probedMinute = toCampaignMinute(probedDate);
    const taken = getAssetCampaigns().some(
      c =>
        c.id !== excludeCampaignId &&
        !c.isModel &&
        c.status !== CampaignStatus.CANCELLED &&
        c.originalCampaignId == null &&
        toCampaignMinute(c.timestamp) === probedMinute,
    );
    return taken ? { uniqueDate: true } : null;
  };
}
